import React, { useState } from "react";
import { connect } from "react-redux";
import ChatPlugin from "./components/chat-plugin-task";
import InspectSection from "./components/inspect-section";

import { useQuery } from "./helpers/hooks/common-hook";
import {useCookies} from "react-cookie";
import ErrorBoundary from "./components/error-boundary";
import {AppContext, getDefaultContext} from "./context/app-context";

export const PUBLISHED_APP_PREFIX = "live";

export const getPublishedApp = (appId) => {
  return `${appId}_${PUBLISHED_APP_PREFIX}`;
};

function App({ voiceModeChangeNotifyMessage }) {
  const query = useQuery();
  const inspect = query.get("inspect");
  const [cookies] = useCookies(["cookie-name"]);

  const [inspectData, setInspectData] = useState({});

  const onChangeInspectData = (data) => {
    setInspectData(data);
  };

  const redirectUrl = "/";
  const redirectMessage = "Try Again";

  const originalAppId = query.get("app_id");

  const appId =
      query.get("test_mode") === "1"
          ? originalAppId
          : getPublishedApp(originalAppId);
  const accessKey = query.get("access_key") || cookies["access-key"];

  return <>
    <ErrorBoundary
        redirectMessage={redirectMessage}
        redirectUrl={redirectUrl}
    >
      {/* <AuthProvider> */}
      <AppContext.Provider
          value={{ ...getDefaultContext(), appInfo: { appId, accessKey } }}
      >
        {inspect?
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-2 overflow-hidden">
              <div className="scrollbars flex-1 h-screen overflow-y-scroll pr-2">
                {/* <InspectSection inspectData={inspectData} /> */}
              </div>
              <div className="flex-1 border-l">
                <ChatPlugin
                    onChangeInspectData={onChangeInspectData}
                    voiceModeChangeNotifyMessage={voiceModeChangeNotifyMessage}
                />
              </div>
            </div>
          :
            <ChatPlugin
                onChangeInspectData={onChangeInspectData}
                voiceModeChangeNotifyMessage={voiceModeChangeNotifyMessage}
            />
        }
      </AppContext.Provider>
      {/* </AuthProvider> */}
    </ErrorBoundary>
  </>
}

const mapsStateToProps = (state) => {
  return {
    voiceModeChangeNotifyMessage: state.voiceModeChangeNotifyMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  console.debug(dispatch);
  return {};
};

export default connect(mapsStateToProps, mapDispatchToProps)(App);
